import util from '../util'

let controller = 'v1/regulatorio/sisbajud/oficios'
export default Object.assign({}, util.GetCrud(controller, null), {
  Listar: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  ListarDepositos: function (codigo, dto) {
    return util.Axios.GetAll(controller + `/${codigo}/depositos-judiciais`, dto)
  },
  SetarEscondido: function (codigo, valor) {
    return util.Axios.Patch(controller + `/${codigo}`, {escondidoBackoffice: valor} )
  }
})
